module.exports = __webpack_public_path__ + "static/media/cf_backgrand_01.5ac85ed1.png";